<template>
    <div class="tools-tab tools-tab-duty">
        <ul class="list list-duties">
            <li v-for="duty in activeDuties" @click="select(duty)">
                <em :style="'background:' + duty.color">{{ duty.identifier }}</em>
                <span>{{ duty.name }}</span>
                <icon name="check" />
            </li>
        </ul>
    </div>
</template>

<script>
import events from '../../../events/events';
import shared from '../../../pages/planning/shared';

export default
{
    name: 'NewDuty',

    props: ['date'],

    data() {
        return {
            shared: shared.state,
        }
    },

    computed:
    {
        // only show duties for this user
        duties()
        {
            return this.sort(this.shared.duties);
        },

        activeDuties()
        {
            return _.filter(this.duties, {trashed: false});
        },
    },

    methods:
    {
        sort(duties)
        {
            return _.sortBy(duties, ['name']);
        },

        select(duty)
        {
            let item =
            {
                assigned: false,
                duty: duty.id,
                shift: null,
            };

            events.$emit('items.add', item, this.date);
        },
    },
}
</script>



// WEBPACK FOOTER //
// NewDuty.vue?32aad926